module.exports = __webpack_public_path__ + "img/nuestro_trabajo_2.ce91e8f7.jpg";